import { HiOutlineUsers } from "react-icons/hi2";
import { FiEdit, FiUserPlus } from "react-icons/fi";
import { TbSmartHome } from "react-icons/tb";
import { IoPersonOutline } from "react-icons/io5";

// ADMIN MENU
export const adminMenuItems = [
  { name: "Fanlar", path: "/admin/subjects", icon: <TbSmartHome /> },
  { name: "Foydalanuvchilar", path: "/admin/users", icon: <HiOutlineUsers /> },
  { name: "Asosiy sahifa", path: "/admin/main", icon: <FiEdit /> },
  {
    name: "Foydalanuvchi qo'shish",
    path: "/admin/student_add",
    icon: <FiUserPlus />,
  },
];

// TEACHER MENU
export const teacherMenuItems = [
  { name: "Fanlar", path: "/teacher", icon: <TbSmartHome /> },
  {
    name: "O‘quvchi qo'shish",
    path: "/teacher/students/add",
    icon: <HiOutlineUsers />,
  },
];

// STUDENT MENU
export const studentMenuItems = [
  { name: "Fanlar", path: "/student", icon: <TbSmartHome /> },
  {
    name: "Shaxsiy kabinet",
    path: "/student/profile",
    icon: <IoPersonOutline />,
  },
];
